var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatBot({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#91BFE3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 13C22 13.9319 21.3626 14.715 20.5 14.937V16.5H25C25.9739 16.5 26.7851 17.196 26.9635 18.1178C26.9757 18.1208 26.9879 18.1239 27 18.127V26.5C27 27.6046 26.1046 28.5 25 28.5H15C13.8954 28.5 13 27.6046 13 26.5L13 18.127L13.0365 18.1178C13.2149 17.196 14.0261 16.5 15 16.5H19.5V14.937C18.6374 14.715 18 13.9319 18 13C18 11.8954 18.8954 11 20 11C21.1046 11 22 11.8954 22 13ZM18.5 21.5C18.5 20.6716 17.8284 20 17 20C16.1716 20 15.5 20.6716 15.5 21.5C15.5 22.3284 16.1716 23 17 23C17.8284 23 18.5 22.3284 18.5 21.5ZM23 23C23.8284 23 24.5 22.3284 24.5 21.5C24.5 20.6716 23.8284 20 23 20C22.1716 20 21.5 20.6716 21.5 21.5C21.5 22.3284 22.1716 23 23 23ZM18 25.5C18 25.7761 18.2239 26 18.5 26H21.5C21.7761 26 22 25.7761 22 25.5C22 25.2239 21.7761 25 21.5 25H18.5C18.2239 25 18 25.2239 18 25.5ZM12 18.5359C11.6979 18.7103 11.4193 18.9239 11.1716 19.1716C10.8001 19.543 10.5055 19.984 10.3045 20.4693C10.1035 20.9546 10 21.4747 10 22C10 22.5253 10.1035 23.0454 10.3045 23.5307C10.5055 24.016 10.8001 24.457 11.1716 24.8284C11.4193 25.0761 11.6979 25.2897 12 25.4641V18.5359ZM28.8284 24.8284C28.5807 25.0761 28.3021 25.2897 28 25.4641V18.5359C28.3021 18.7103 28.5807 18.9239 28.8284 19.1716C29.1999 19.543 29.4945 19.984 29.6955 20.4693C29.8965 20.9546 30 21.4747 30 22C30 22.5253 29.8965 23.0454 29.6955 23.5307C29.4945 24.016 29.1999 24.457 28.8284 24.8284Z",
    fill: "#23366F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBot);
export default __webpack_public_path__ + "static/media/ChatBot.7f5d4c21c64fe0758d62974e80298364.svg";
export { ForwardRef as ReactComponent };